import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'HELP_CENTER',
    icon: 'menu-help-center',
    label: '帮助中心',
    placement: 'bottom',
    path: '/help-center',
    public: true,
  },
] satisfies Menu[];
